import { BadgeVariants } from '@carboledger/ui';
import { CONTRACT_STATUS_TONE } from '@/config/statusTones';

// Badge tone per contract status, for the modal's status field.

// The discrepancy modal's field sections — shared by the list and the details page.
export const buildContractDiscrepancySections = (t, contract) => {
  if (!contract) return [];
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: contract.materialName },
        {
          label: t('FIELD_STATUS'),
          value: contract.statusLabel,
          type: 'status',
          tone: CONTRACT_STATUS_TONE[contract.status] ?? BadgeVariants.default,
        },
        { label: t('FIELD_SENT_BY'), value: contract.supplierName },
        { label: t('FIELD_RECEIVED_AT'), value: contract.facilityName },
        { label: t('FIELD_TERMINAL'), value: contract.terminal },
        { label: t('FIELD_DISPATCH_BY'), value: contract.dispatchBy },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        {
          label: t('FIELD_CONTRACTED_QUANTITY'),
          value: contract.workingQuantities.contracted,
        },
        { label: t('FIELD_SHIPPED_QUANTITY'), value: contract.workingQuantities.shipped },
        {
          label: t('FIELD_OUTSTANDING_QUANTITY'),
          value: contract.workingQuantities.outstanding,
        },
      ],
    },
  ];
};
